import SelectableCardGroup from './common/SelectableCardGroup';

const CHOICES = [
  { key: 'fit', title: '핏이 정말 다르다고 느껴질 때', desc: '체형에 딱 맞는 실루엣이 가장 중요해요', icon: 'ri-user-smile-line' },
  { key: 'fabric', title: '원단의 고급감이 느껴질 때', desc: '촉감과 광택, 원단 퀄리티를 먼저 보나봐요', icon: 'ri-t-shirt-line' },
  { key: 'consult', title: '상담이 편하고 부담이 없을 때', desc: '압박 없이 내 취향을 존중해주는 곳이 좋아요', icon: 'ri-chat-heart-line' },
  { key: 'photo', title: '사진 분위기가 예쁠 때', desc: '스튜디오 촬영과 본식 사진의 완성도가 중요해요', icon: 'ri-camera-line' },
  { key: 'price', title: '가격 만족도가 좋을 때', desc: '투자한 만큼 확실한 가치를 느끼고 싶어요', icon: 'ri-hand-coin-line' },
];

interface StepTasteProps {
  value: string | null;
  onChange: (val: string) => void;
}

export default function StepTaste({ value, onChange }: StepTasteProps) {
  return <SelectableCardGroup options={CHOICES} value={value} onChange={onChange} />;
}
